import { defineMessages } from 'react-intl';

export const socialLinkTypeIds = {
  // website: 'website',
  // blog: 'blog',
  facebook: 'facebook',
  twitter: 'twitter',
  linkedIn: 'linked-in',
  telegram: 'telegram',
  slack: 'slack',
  // youtube: 'youtube',
  github: 'github',
};

export const socialLinkTypeIdsOrder = [
  // socialLinkTypeIds.website,
  // socialLinkTypeIds.blog,
  socialLinkTypeIds.facebook,
  socialLinkTypeIds.twitter,
  socialLinkTypeIds.linkedIn,
  socialLinkTypeIds.telegram,
  socialLinkTypeIds.slack,
  // socialLinkTypeIds.youtube,
  socialLinkTypeIds.github,
];

export const socialLinkTypes = {
  // [socialLinkTypeIds.website]: {
  //   messages: defineMessages({
  //     name: {
  //       id: 'companies.social-links.messages.website.name',
  //       defaultMessage: 'Website',
  //     },
  //   }),
  //   buttonClass: 'btn btn-secondary',
  //   iconCustomClass: 'icon--website',
  //   iconFaClass: 'fa fa-globe',
  // },
  // [socialLinkTypeIds.blog]: {
  //   messages: defineMessages({
  //     name: {
  //       id: 'companies.social-links.messages.blog.name',
  //       defaultMessage: 'Blog',
  //     },
  //   }),
  //   buttonClass: 'btn btn-secondary',
  //   iconCustomClass: '',
  //   iconFaClass: 'fa fa-rss-square',
  // },
  [socialLinkTypeIds.facebook]: {
    messages: defineMessages({
      name: {
        id: 'companies.social-links.messages.facebook.name',
        defaultMessage: 'Facebook',
      },
    }),
    buttonClass: 'btn btn-facebook',
    iconCustomClass: 'icon--facebook',
    iconFaClass: 'fa fa-facebook',
    domains: ['facebook.com', 'www.facebook.com'],
  },
  [socialLinkTypeIds.twitter]: {
    messages: defineMessages({
      name: {
        id: 'companies.social-links.messages.twitter.name',
        defaultMessage: 'Twitter',
      },
    }),
    buttonClass: 'btn btn-twitter',
    iconCustomClass: 'icon--twitter',
    iconFaClass: 'fa fa-twitter',
    domains: ['twitter.com', 'www.twitter.com'],
  },
  [socialLinkTypeIds.linkedIn]: {
    messages: defineMessages({
      name: {
        id: 'companies.social-links.messages.linked-in.name',
        defaultMessage: 'LinkedIn',
      },
    }),
    buttonClass: 'btn btn-linkedin',
    iconCustomClass: '',
    iconFaClass: 'fa fa-linkedin',
    domains: ['linkedin.com', 'www.linkedin.com'],
  },
  [socialLinkTypeIds.telegram]: {
    messages: defineMessages({
      name: {
        id: 'companies.social-links.messages.telegram.name',
        defaultMessage: 'Telegram',
      },
    }),
    domains: ['telegram.org', 'www.telegram.org'],
    buttonClass: 'btn btn-telegram',
    iconCustomClass: 'icon--telegram',
    iconFaClass: 'fa fa-telegram',
  },
  [socialLinkTypeIds.slack]: {
    messages: defineMessages({
      name: {
        id: 'companies.social-links.messages.slack.name',
        defaultMessage: 'Slack',
      },
    }),
    domains: ['slack.com', 'www.slack.com'],
    buttonClass: 'btn btn-slack',
    iconCustomClass: '',
    iconFaClass: 'fa fa-slack',
  },
  // [socialLinkTypeIds.youtube]: {
  //   messages: defineMessages({
  //     name: {
  //       id: 'companies.social-links.messages.youtube.name',
  //       defaultMessage: 'YouTube Channel',
  //     },
  //   }),
  //   domains: ['youtube.com', 'www.youtube.com', 'youtu.be'],
  //   buttonClass: 'btn btn-youtube',
  //   iconCustomClass: 'icon--youtube',
  //   iconFaClass: 'fa fa-youtube-play',
  // },
  [socialLinkTypeIds.github]: {
    messages: defineMessages({
      name: {
        id: 'companies.social-links.messages.github.name',
        defaultMessage: 'GitHub',
      },
    }),
    domains: ['github.com', 'www.github.com'],
    buttonClass: 'btn btn-github',
    iconCustomClass: 'icon--github',
    iconFaClass: 'fa fa-github',
  },
};

export const defaultSocialLinks = socialLinkTypeIdsOrder.map(socialLinkTypeId => ({
  type: socialLinkTypeId,
  url: '',
}));

export const socialLinkTypeIdsOrderForProfile = [
  socialLinkTypeIds.facebook,
  socialLinkTypeIds.twitter,
  socialLinkTypeIds.linkedIn,
  socialLinkTypeIds.github,
];

export const defaultSocialLinksForProfile = socialLinkTypeIdsOrderForProfile.map(
  socialLinkTypeId => ({
    type: socialLinkTypeId,
    url: '',
  })
);



// WEBPACK FOOTER //
// ./src/ui/common/social-links/index.js